module.exports = __webpack_public_path__ + "static/media/sk.e995322e.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/sk.svg
// module id = 979
// module chunks = 0